import request from '@/utils/http.js'

// 创建账号
export const openRegister = (params) => {
  return request({
    url: `/authority-center/open/register`,
    method: 'post',
    params
  })
}

// 获取分类列表
export const getcatloglist = (params) => {
  return request({
    url: `/cms-service/open/list`,
    method: 'get',
    params
  })
}
